export const formatBytes = (
	num: number,
	options: Intl.NumberFormatOptions = {
		notation: 'compact',
		style: 'unit',
		unit: 'byte',
		unitDisplay: 'narrow',
	}
) => {
	return new Intl.NumberFormat('en-US', options).format(num);
};

export const formatNumber = (num: number, options: Intl.NumberFormatOptions = {}) => {
	return new Intl.NumberFormat('en-US', options).format(num);
};

export const formatPercentage = (value: number, locales: Intl.LocalesArgument = 'en-US') => {
	let minimumFractionDigits = 0;
	let maximumFractionDigits = 1;

	// add two decimal places for values less than 1
	if (value < 1 && value !== 0) {
		minimumFractionDigits = 2;
		maximumFractionDigits = 2;
	}

	return new Intl.NumberFormat(locales as string | string[] | undefined, {
		style: 'percent',
		minimumFractionDigits,
		maximumFractionDigits,
	}).format(value / 100);
};
